import React from "react";

import { ToolTip } from "../../AbstractElements";
import { sanitizeString } from "../../utils/helper/helper";
import P from "../Paragraph";

interface EllipsisWithTooltipProps {
  textList: string[];
  idPrefix: string;
}

const EllipsisWithTooltip: React.FC<EllipsisWithTooltipProps> = ({
  textList,
  idPrefix,
}) => {
  const tooltipId = sanitizeString(`tooltip-${idPrefix}`);

  if (!textList || textList.length === 0) return null;

  return (
    <div className="creator w-100">
      <span id={tooltipId}>
        <div className="text-ellips-parent">
          <P
            className="header-text text-ellips pointer"
            data-fulltext={textList}
          >
            {textList[0]}
            {textList.length > 1 && (
              <span className="ms-2">+{textList.length - 1}</span>
            )}
          </P>
        </div>
      </span>

      <ToolTip placement="top" target={tooltipId}>
        {textList.join(", ")}
      </ToolTip>
    </div>
  );
};

export default EllipsisWithTooltip;
